import { ReactNode } from 'react';

type TitleProps = {
  children?: ReactNode;
};

export const Title = ({ children }: TitleProps) => <span>{children}</span>;
